/** View-model tab "Mẫu định kỳ": chia mẫu thành Thu / Chi / Trả thẻ & nợ / Hằng năm / Đã tắt, tổng theo tháng. Thuần hàm, có test. */
export type TemplateSectionId = 'income' | 'expense' | 'payment' | 'yearly' | 'off';
export interface TemplateSection { id: TemplateSectionId; label: string; items: any[]; total: number }
export interface TemplateView { sections: TemplateSection[]; income: number; expense: number; payment: number; net: number }

const num = (v: unknown) => Number(v) || 0;
const byDay = (a: any, b: any) => num(a.dayOfMonth || 1) - num(b.dayOfMonth || 1) || String(a.name).localeCompare(String(b.name), 'vi');
const byYear = (a: any, b: any) => num(a.monthOfYear || 1) - num(b.monthOfYear || 1) || byDay(a, b);

export const groupTemplates = (templates: any[]): TemplateView => {
  const on = templates.filter(t => t.active !== false);
  const monthly = on.filter(t => t.frequency !== 'yearly');
  const sum = (type: string) => monthly.filter(t => t.type === type).reduce((s, t) => s + num(t.amount), 0);
  const income = sum('income'), expense = sum('expense'), payment = sum('payment');
  const sec = (id: TemplateSectionId, label: string, items: any[], total: number, sort = byDay): TemplateSection => ({ id, label, items: [...items].sort(sort), total });
  const sections = [
    sec('income', 'Thu mỗi tháng', monthly.filter(t => t.type === 'income'), income),
    sec('expense', 'Chi mỗi tháng', monthly.filter(t => t.type === 'expense'), expense),
    sec('payment', 'Trả thẻ và nợ mỗi tháng', monthly.filter(t => t.type === 'payment'), payment),
    sec('yearly', 'Hằng năm', on.filter(t => t.frequency === 'yearly'), on.filter(t => t.frequency === 'yearly' && t.type !== 'income').reduce((s, t) => s + num(t.amount), 0), byYear),
    sec('off', 'Đã tắt', templates.filter(t => t.active === false), 0)
  ].filter(s => s.items.length > 0);
  return { sections, income, expense, payment, net: income - expense - payment };
};
